import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { format, startOfMonth } from 'date-fns';
import type { FaixaNotaBko, TipoBko } from './useNotaBkoMes';

export interface NotaEquipeLinha {
  usuario_id: string;
  nome: string;
  funcao: string;
  tipo: TipoBko;
  nota: number;
  faixa: FaixaNotaBko;
  diagnostico: string;
  equipe_id: string | null;
  role: string | null;
}

/**
 * Nota Prime mensal de todas as pessoas que possuem régua, com equipe e perfil
 * para aplicar a visão hierárquica do cabeçalho.
 *
 * Douglas (21/08/2026): a nota de cada um no topo da página, e para o master a
 * lista com todos os nomes.
 */
export function useNotasBkoEquipe(competencia?: Date, enabled = true) {
  const comp = format(startOfMonth(competencia ?? new Date()), 'yyyy-MM-dd');
  return useQuery<NotaEquipeLinha[]>({
    queryKey: ['notas-bko-equipe', comp],
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('notas_prime_painel' as never, { p_competencia: comp } as never);
      if (error) throw error;
      return (data || []) as unknown as NotaEquipeLinha[];
    },
  });
}
